import { Box, Typography } from "@mui/material";
import { BrandNameUpdate } from "../../../../utils/commonFunctions/BrandNameUpdate";
import { RoutingURLs } from "../../../../config/RoutingURLs";

type Props = {
  c_num: any;
  styles: any;
  setOpenSupportDialog: any;
  content?:any;
};

const PinHelperText = (props: Props) => {
  const { c_num, styles, setOpenSupportDialog } = props;
  return (
    <>
      <Box mb="20px" pt="40px">
        <Typography className={styles.btm_title} sx={{ mb: "5px" }}>
          {c_num?.pin}
        </Typography>
        <Typography className={styles.btm_description} sx={{fontFamily: "var(--font_family_Regular)", fontSize: "14px"}}>
          {BrandNameUpdate(c_num?.pin_txt)}
        </Typography>
      </Box>
      <Box>
        <Typography className={styles.btm_title} sx={{ mb: "5px" }}>
          {c_num?.car_info}
        </Typography>
        <Typography className={styles.btm_description} sx={{fontFamily: "var(--font_family_Regular)", fontSize: "14px"}}>
          {c_num?.car_info_txt}&nbsp;
          <span
            // className={styles.btm_title}
            style={{
              color: "var(--dusk)",
              cursor: "pointer",
            }}
            onClick={() =>
              props?.content?.whh_new_tab
                ? window.open(RoutingURLs.contactUs, "_blank")
                : setOpenSupportDialog(true)
            }          >
            {c_num?.help_txt}
          </span>
        </Typography>
      </Box>
    </>
  );
};
export default PinHelperText;
